import axios, { AxiosResponse } from 'axios';
import { Logger } from 'ia-react-core';
import Constants from '../Constants';
import { getLanguage } from '../utils/getLanguage';
import { ContentItem } from '../interfaces/ContentItem';
import { getSiteCoreQuery } from '../utils/getSiteCoreQuery';
import { escapeWhiteSpaces } from '../utils/escapeWhiteSpaces';
import { getHostName } from '../utils/getHostName';
import { getExperience } from '../utils/getExperience';
import { getLanguageFromLocale } from '../utils/getLanguageFromLocale';

export const buildContentUrl = (path: string, isChildren: boolean, locale?: string, getOnlySubQueryPath?: boolean): string => {
  const url = getSiteCoreQuery(path, isChildren, locale, getOnlySubQueryPath);
  return escapeWhiteSpaces(url);
};

export const fetchUrls = async (urls: string[], logger: Logger): Promise<ContentItem[]> => {
  try {
    const datas = await Promise.all(urls.map((u: string) => axios.get<ContentItem>(u)));
    return datas.map((d: AxiosResponse) => d.data as ContentItem);
  } catch (error) {
    logger.error(error);
    return [];
  }
};

export function getContentItemFieldValue(content: ContentItem, fieldName: string): string {
  if (!content || !fieldName || !content?.Fields) return '';

  const lowerCaseFieldName = fieldName.toLowerCase();
  const fieldsFiltered = content.Fields.filter((x) => lowerCaseFieldName === x.Name.toLowerCase());
  return fieldsFiltered[0]?.Value ?? '';
}

export function buildJssQuery(itemPath: string, locale?: string): string {
  const sitecoreHostName = getHostName();
  const site = getExperience();
  let language = getLanguageFromLocale(locale);
  if (!language) language = getLanguage();
  return encodeURI(`${sitecoreHostName}/sitecore/api/layout/render/jss?item=${itemPath}&sc_apikey=${Constants.apiKeyJss}&sc_site=${site}&sc_lang=${language}`);
}
